import { omrehBaseClient } from "./client";

const GetGuestServicesDetailsId = (data) => {
    return omrehBaseClient.post('/GuestServicesDetails/GetGuestServicesDetailsId', {
        "guestServices": data.guestServices,
        "guestServiceType": data.guestServiceType,
        "cityConsistency": data.cityConsistency,
        "operation": data.operation,
        "hotelId": data.hotelId
    }
    )
}
// const GetAll=()=> {
//     return omrehBaseClient
//     .get("/GuestServicesDetails");
// }

// const GetCurrentOperationServices=()=> {
//     return omrehBaseClient
//     .get("/GetCurrentOperationServices");
// }

const GetGuestServicesGroupedByCityAndType=()=> {
    return omrehBaseClient
    .get("/GuestServicesDetails/GetGuestServicesGroupedByCityAndType");
}

const GetGuestHotelByCityDropDown = (cityConsistency) => {
  return omrehBaseClient
    .get("/GuestServicesDetails/GetGuestHotelByCityDropDown", {
      params: {
        'cityConsistency': cityConsistency
      }
    });
}

const GetServicesDropDown = () => {
  return omrehBaseClient
    .get("/GuestServicesDetails/GetServicesDropDown");
}

const GetServicesTypeDropDown = (status) => {
  return omrehBaseClient
    .get("/GuestServicesDetails/GetServicesTypeDropDown", {
      params: {
        'guestServices': status
      }
    });
}

const guestServicesDetailsApi = {
    GetGuestServicesDetailsId, GetGuestHotelByCityDropDown, GetGuestServicesGroupedByCityAndType, GetServicesDropDown, GetServicesTypeDropDown
}

export default guestServicesDetailsApi